export const formatNumber = (value, fractionDigits = 2) => {
  if (isNaN(Number(value))) return '';

  const result = Number(value)
    .toLocaleString('ru-ru', { minimumFractionDigits: fractionDigits, maximumFractionDigits: 2 })
    .replace(',', '.');

  return result;
}
